import React, { useState } from "react";
import Advocate from "../../Images/Advocate.png";
import LandingNavbar from "../navbar/LandingNavbar";
import Footer from "../../pages/Footer";

export default function AdvocateForm() {
  const [form, setForm] = useState({
    name: "",
    barId: "",
    year: "",
    noOfYear: "",
    captcha: "",
  });

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("submit", form);
    // TODO: hook into your signup API...
  };

  return (
    <>
      <LandingNavbar />
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-full px-4 sm:px-6 lg:px-0 mx-auto max-w-sm sm:max-w-md md:max-w-lg lg:max-w-lg bg-blue-100 p-4 rounded-xl relative">
          {/* Icon in circle */}
          <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-gray-50 border-spacing-2 rounded-full p-2">
            <img src={Advocate} alt="Building Icon" className="h-16 w-16" />
          </div>

          <h2 className="text-xl font-semibold text-gray-900 text-center mt-6 mb-4">
            Please Enter Your Details
          </h2>

          {/* Added flex flex-col items-center so children (if narrower) stay centered */}
          <form
            onSubmit={handleSubmit}
            className="space-y-2 px-6 py-4 flex flex-col items-center"
          >
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            <select
              name="barDistrict"
              value={form.barDistrict}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
              required
            >
              <option value="">Select</option>
              <option value="None">None</option>
              <option value="District Bar Association - Dehradun">
                District Bar Association - Dehradun
              </option>
              <option value="District Bar Association - Haridwar">
                District Bar Association Haridwar
              </option>
              <option value="District Bar Association - Tehri Garhwal">
                District Bar Association Tehri Garhwal
              </option>
              <option value="District Bar Association - Pauri Garhwal">
                District Bar Association Pauri Garhwal
              </option>
              <option value="District Bar Association - Uttarkashi">
                District Bar Association Uttarkashi
              </option>
              <option value="District Bar Association - Chamoli">
                District Bar Association Chamoli
              </option>
              <option value="District Bar Association - Rudraprayag">
                District Bar Association Rudraprayag
              </option>
              <option value="District Bar Association - Almora">
                District Bar Association Almora
              </option>
              <option value="District Bar Association - Bageshwar">
                District Bar Association Bageshwar
              </option>
              <option value="District Bar Association - Champawat">
                District Bar Association Champawat
              </option>
              <option value="District Bar Association - Nainital">
                District Bar Association Nainital
              </option>
              <option value="District Bar Association - Pithoragarh">
                District Bar Association Pithoragarh
              </option>
              <option value="District Bar Association - Udham Singh Nagar">
                District Bar Association Udham Singh Nagar
              </option>
            </select>

            <input
              type="text"
              name="barId"
              placeholder="Bar ID"
              value={form.barId}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            <input
              type="date"
              name="year"
              placeholder="Year"
              value={form.year}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            <select
              name="noOfYear"
              value={form.noOfYear}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200"
              required
            >
              <option value="">No. of Year</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>

            {/* Captcha display */}
            <div className="w-full bg-gray-100 border border-gray-200 rounded-lg flex justify-center items-center">
              <span className="text-lg font-mono tracking-wide">98-9=?</span>
            </div>
            <input
              type="text"
              name="captcha"
              placeholder="Please Enter Captcha"
              value={form.captcha}
              onChange={handleChange}
              className="w-full bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-200 text-base"
              required
            />

            {/* Centered button via mx-auto */}
            <button
              type="submit"
              className="mx-auto w-1/2 bg-blue-500 text-white py-2 rounded-full text-lg hover:bg-blue-600 transition-colors"
            >
              Sign Up
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}
